angular.module('property')
    .controller('PropertyAssetGroupController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, Property, Project) {
        this.$onInit = () => {
            if(data.property.project != null) {
                Project.assetGroups({id: data.property.project.id}).$promise.then(result => {
                    this.projectAssetGroups = result;
                })
            }
            this.item = angular.copy(data.property);
            this.form = {
                id: this.item.id,
                action: 'asset-groups',
                assetGroups: angular.copy(this.item.assetGroups),
            }
        }
        this.isChecked = group => {
            return (this.form.assetGroups instanceof Array) && this.form.assetGroups.find(g => g.name === group.name) != null
        }
        this.toggle = group => {
            if (!this.form.assetGroups) {
                this.form.assetGroups = [];
            }
            let el = this.form.assetGroups.find(g => g.name === group.name)
            if (el != null) {
                this.form.assetGroups = this.form.assetGroups.filter(g => g.name !== group.name);
            } else {
                this.form.assetGroups.push(group);
            }
        }
        this.selectAll = () => {
            this.form.assetGroups = angular.copy(this.projectAssetGroups);
        }
        this.clearAll = () => {
            this.form.assetGroups = [];
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return Property.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })

    .controller('PropertyAdditionalAssetGroupsController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, Property, Project) {
        this.$onInit = () => {
            if(data.property.project != null) {
                Project.assetGroups({id: data.property.project.id}).$promise.then(result => {
                    this.projectAssetGroups = result;
                })
            }
            this.item = angular.copy(data.property);
            this.form = {
                id: this.item.id,
                action: 'additional-asset-groups',
                assetGroups: angular.copy(this.item.additionalAssetGroups),
            }
        }
        this.isChecked = group => {
            return (this.form.assetGroups instanceof Array) && this.form.assetGroups.find(g => g.name === group.name) != null
        }
        this.toggle = group => {
            if (!this.form.assetGroups) {
                this.form.assetGroups = [];
            }
            let el = this.form.assetGroups.find(g => g.name === group.name)
            if (el != null) {
                this.form.assetGroups = this.form.assetGroups.filter(g => g.name !== group.name);
            } else {
                this.form.assetGroups.push(group);
            }
        }
        this.selectAll = () => {
            this.form.assetGroups = angular.copy(this.projectAssetGroups);
        }
        this.clearAll = () => {
            this.form.assetGroups = [];
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return Property.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })
